import script from "./DataInconsistencyStateAllTestsPassed.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataInconsistencyStateAllTestsPassed.vue?vue&type=script&setup=true&lang=ts"

import "./DataInconsistencyStateAllTestsPassed.vue?vue&type=style&index=0&id=2c6c289f&lang=scss"

const __exports__ = script;

export default __exports__